import { useState, useEffect } from "react";
import { useWeb3React } from "@web3-react/core";
import { Rings } from "react-loader-spinner";

// Import react-customizable-progressbar module
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { Alert } from "../components/Alert";
import { WorkCard } from "../components/Cards";
import { LionImage } from "../components/Images";
import { ErrorModal } from "../components/Modal";
import { GradientButton, LinkButton } from "../components/Buttons";
import {
  getErrorMessageFromTxResult,
  getTxHashFromTxResult,
  fetchPost,
} from "../utils/utils";
import "./mint.css";
import { Page } from "../api";
import { LIONTRAVELERS_CONTRACT_ADDRESS } from "../Web3/contractAddress";
import { web3LionTravelerInstance } from "../Web3/hook";

const Mint = () => {
  let { library, account, active, chainId } = useWeb3React();
  document.title = "Lion Travelers Mint";
  const page = Page();
  const [mintPrice, setMintPrice] = useState(0);
  const [mintAmount, setMintAmount] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0);
  const [saleStatus, setSaleStatus] = useState(false);
  const [isRunningTx, setIsRunningTx] = useState(false);
  const [errorContent, setErrorContent] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [currentMintAmount, setCurrentMintAmount] = useState(0);
  const [transactionHash, setTransactionHash] = useState("");
  const [transactionResult, setTransactionResult] = useState("");
  const [totalMintAmountOfEdition, setTotalMintAmountOfEdition] =
    useState(1111);

  const decreaseMintAmount = () => {
    if (mintAmount - 1 < 1) setMintAmount(1);
    else setMintAmount(mintAmount - 1);
  };

  const increaseMintAmount = () => {
    if (mintAmount + 1 > 1111) setMintAmount(1111);
    else setMintAmount(mintAmount + 1);
  };

  const handleMintAmount = (e) => {
    let inputValue = Number.parseInt(e.target.value);
    if (inputValue < 1) {
      alert("Please enter more than 1");
    } else if (inputValue > 1111) {
      alert("Please enter less than 1111");
    } else if (!inputValue) {
      inputValue = 0;
    } else {
      setMintAmount(inputValue);
    }
  };

  const getIpfsIdFromTokenId = (tokenId) => {
    return Number.parseInt(tokenId) % 1111;
  };

  const handleMint = async () => {
    if (!active) {
      setErrorContent("Please connect wallet.");
      setShowErrorModal(true);
      return;
    }

    let mintPrice = library.utils.toWei(Number(totalPrice).toString(), "ether");
    let callOk = true;
    try {
      await web3LionTravelerInstance().methods
        .Mint(mintAmount)
        .call({ from: account, value: mintPrice });
    } catch (err) {
      callOk = false;
      setErrorContent(getErrorMessageFromTxResult(err));
      setShowErrorModal(true);
    }
    if (callOk) {
      try {
        setIsRunningTx(true);
        let result = await web3LionTravelerInstance().methods
          .Mint(mintAmount)
          .send({ from: account, value: mintPrice });
        if (result) {
          let tokenId = result.events.Transfer.returnValues.tokenId;
          let url = page.api.nft.collection.mint.url;
          let params = {
            ...page.api.nft.collection.mint.params,
            ...{
              edition: Math.floor(Number.parseInt(tokenId) / 1111) + 1,
              wallet_address: result.from,
              amount: 0,
              currency: "ETH",
              usd: 0,
              apr: 0,
              keypass: "myuritest.com/hash",
            },
          };
          console.log("url", url);
          console.log("params", params);
          console.log("getIpfsIdFromTokenId(tokenId)", getIpfsIdFromTokenId(tokenId));
          let res = await fetchPost(
            url,
            {
              ...params,
              ipfs_id: getIpfsIdFromTokenId(tokenId),
              txn_hash: result.events.Transfer.transactionHash,
            },
            page.headers
          );
          console.log("res", res);
          if (!res) {
            setTransactionResult("danger");
          } else {
            setTransactionResult("success");
            setTransactionHash(result.transactionHash);
          }
          setIsRunningTx(false);
        }
      } catch (err) {
        setIsRunningTx(false);
        if (err.code === 4001) {
          setErrorContent(err.message);
          setShowErrorModal(true);
        } else {
          setTransactionResult("danger");
          setTransactionHash(getTxHashFromTxResult(err));
        }
      }
    }
  };

  const mintText = "Collect unique NFT art pieces, become part of our community!";

  const contractUrl = "https://goerli.etherscan.io/address/" + LIONTRAVELERS_CONTRACT_ADDRESS;

  useEffect(() => {
    const fetchData = async () => {
      try {
        let totalSupply = await web3LionTravelerInstance().methods.totalSupply().call();
        let totalMint = await web3LionTravelerInstance().methods.editionSupply().call();
        let sale = await web3LionTravelerInstance().methods.sale().call();

        setCurrentMintAmount(totalSupply);
        setTotalMintAmountOfEdition(totalMint);
        setSaleStatus(sale);
      } catch (err) {
        setErrorContent(getErrorMessageFromTxResult(err));
        setShowErrorModal(true);
      }
    };
    fetchData();
    setInterval(fetchData, 10000);
  }, []);

  useEffect(() => {
    const getMintPrice = async () => {
      if (account) {
        let price = await web3LionTravelerInstance().methods.getMintPrice(account).call();
        setMintPrice(price);
      }
    }
    getMintPrice();
  }, [account])

  useEffect(() => {
    setTotalPrice((mintAmount * mintPrice) / 1e18);
  }, [mintAmount, mintPrice]);

  return (
    <section id="mint">
      <div className="container">
        <div className="row">
          <ErrorModal
            title={"Error"}
            content={errorContent}
            onClose={() => setShowErrorModal(false)}
            show={showErrorModal}
          />
          <LionImage />
          <WorkCard title="Mint Lion Traveler NFT" text={mintText}>
            <div
              className="text-white-50 card-text d-flex mx-auto"
              style={{ width: "fit-content" }}
            >
              <div
                label="Default"
                className="progress-parent"
                style={{
                  width: "17px",
                  height: "18px",
                  position: "relative",
                  top: "-3px",
                }}
              >
                <CircularProgressbar
                  value={currentMintAmount / totalMintAmountOfEdition}
                  style={{ width: "100%" }}
                  styles={buildStyles({
                    pathColor: "rgba(255,255,255,0.5)",
                    trailColor: "rgba(255,255,255,0.1)",
                  })}
                />
              </div>
              <span>&nbsp;{currentMintAmount % totalMintAmountOfEdition}</span>&nbsp;/{" "}
              {totalMintAmountOfEdition}
              &nbsp;already minted
            </div>
            <div className="row box-pre-input">
              <div className="col-12">
                <div className="h-10">
                  <span style={{ color: "rgb(197, 197, 197)" }}>Amount:</span>
                  <div className="input-group w-32">
                    <button
                      className="btn bg-gray-300 text-gray-600 input-btn"
                      type="button"
                      data-action="decrement"
                      onClick={decreaseMintAmount}
                    >
                      -
                    </button>
                    <input
                      className="form-control text-gray-700 bg-gray-300 w-full input-btn"
                      type="number"
                      min="1"
                      value={mintAmount}
                      onChange={handleMintAmount}
                    />
                    <button
                      className="btn bg-gray-300 text-gray-600 outline-none input-btn"
                      type="button"
                      data-action="increment"
                      onClick={increaseMintAmount}
                    >
                      +
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="h-10">
                  <span>
                    <span style={{ color: "rgb(197, 197, 197)" }}>Total:</span>
                  </span>
                  <h4>{totalPrice} ETH</h4>
                </div>
              </div>
            </div>
            <GradientButton
              text={saleStatus ? "MINT" : "PAUSED"}
              onClick={handleMint}
            />
            <div>
              <a href={contractUrl} target="_blank" rel="noreferrer noopener">
                Smart contract<i className="fas fa-external-link-alt"></i>
              </a>
            </div>
            {isRunningTx ? (
              <div className="d-flex justify-content-center text-center">
                <Rings color="#555" height={50} width={50} />
              </div>
            ) : (
              ""
            )}
            {transactionResult !== "" ? (
              <Alert status={transactionResult}>
                <LinkButton
                  classname=""
                  target="blank"
                  link={"https://rinkeby.etherscan.io/tx/" + transactionHash}
                  text="Show detail in etherscan"
                />
              </Alert>
            ) : (
              ""
            )}
          </WorkCard>
        </div>
      </div>
    </section>
  );
};

export default Mint;
